var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 143.887,
    height: 96.89,
    viewBox: "0 0 143.887 96.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20087",
    "data-name": "Group 20087",
    transform: "translate(-30.5 -66.523)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44453",
    "data-name": "Path 44453",
    d: "M49.453,162.412c-8.063-13.518-9.86-14.159-17.953-27.659,17.887-11.578,35.489-23.542,53.783-34.521,7.621-4.573,16.2-8.256,23.49-13.323.2-.137-8.8-13.88-11.077-18.236,25.2-.544,50.467-1.647,75.69-.948-9.361,21.581-22.528,45.8-34.422,66.487-3.64-3.309-10.345-14.457-12.906-18.77-6.842,3.012-12.645,7.367-19.08,11.15C88.844,137.257,66.781,150.5,49.453,162.412Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44454",
    "data-name": "Path 44454",
    d: "M223.065,67.556c-.159,11.433-.169,24.162-.947,35.567",
    transform: "translate(-65.952 -0.019)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44455",
    "data-name": "Path 44455",
    d: "M200.54,67.68c.47,19.4,1.137,41.227.318,60.623",
    transform: "translate(-58.486 -0.062)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44456",
    "data-name": "Path 44456",
    d: "M178.136,68.236c.472,16.1.267,33.906.267,50.018",
    transform: "translate(-50.735 -0.255)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44457",
    "data-name": "Path 44457",
    d: "M149.652,97.133c1.072,11.32,2.032,25.23,3.358,36.512",
    transform: "translate(-40.88 -10.253)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44458",
    "data-name": "Path 44458",
    d: "M125.744,110.944c-.233,12.249,1.4,25.5,1.918,37.759",
    transform: "translate(-32.6 -15.031)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44459",
    "data-name": "Path 44459",
    d: "M102,124.7c-.559,12.192,1.226,26.258,1.247,38.5",
    transform: "translate(-24.356 -19.79)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44460",
    "data-name": "Path 44460",
    d: "M80.271,138.547c.676,12.013,1.721,25.557,2.544,37.566",
    transform: "translate(-16.874 -24.582)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44461",
    "data-name": "Path 44461",
    d: "M59.073,152.313a297.171,297.171,0,0,0,2.745,37.5",
    transform: "translate(-9.54 -29.345)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.01e55d036391ca8c38155d67785f1840.svg";
export { ForwardRef as ReactComponent };